export const advisingIntro = {
  mission:
    "The AiR Lab is dedicated to developing software for highly autonomous unmanned vehicles that can operate in air, ground, and water. We build robots that function independently, without human oversight, completing intricate assignments across extensive distances and long periods while cooperating with human teams.",
  approach:
    "In our group, the prime directive for graduate students is to focus on the most interesting and impactful research questions. When we examine an autonomy challenge, we prioritize recognizing what robots presently cannot accomplish, pinpointing the technological shortcomings that preceded the current work, and discovering fundamental concepts that apply across different domains.",
};

export const advisingSections = [
  {
    id: 1,
    title: "Advisor's Role",
    body: [
      "As an advisor, my primary responsibilities include helping students identify research questions, framing technical questions, and guiding students on the path to answering these questions. I work closely with each student to ensure they are well-equipped to tackle the challenges in their research.",
    ],
  },
  {
    id: 2,
    title: "Student Expectations",
    body: [
      "Students in the AiR Lab are expected to follow the research path set out for them, execute technical development, and communicate their insights to the community.",
      "I encourage lab attendance at least three times per week and aim for students to publish a novel conference paper annually on average, although this is not a strict requirement, as research often requires patience.",
    ],
  },
  {
    id: 3,
    title: "Emphasis on Writing and Software Development",
    body: [
      "I place significant importance on the writing process, engaging substantially with students in writing and revising papers to produce the best possible work.",
      "Additionally, I consider software development a crucial part of training, ensuring that students' software remains useful and relevant after they complete their degrees.",
    ],
  },
  {
    id: 4,
    title: "Lab Structure and Collaboration",
    body: [
      "The AiR Lab typically consists of 2-6 students. Our structure includes weekly one-on-one meetings with each student and weekly group meetings, which I consider the most important meeting of the week. These group meetings provide opportunities for collaborative learning and engagement.",
      "I strongly encourage collaboration within the group and with other research groups, as I believe research in autonomous robots is a team sport.",
    ],
  },
  {
    id: 5,
    title: "Equity and Inclusion",
    body: [
      "Equity and inclusion are crucial aspects of our lab culture. I view students as research partners and strive to never ask someone to do a task I wouldn't be willing to do myself.",
      "All team members are expected to share responsibilities, with senior students mentoring junior students and junior students contributing to the community from day one. I actively welcome researchers of all identities and support creating a space for lab members to raise and discuss relevant DEI topics in robotics.",
    ],
  },
  {
    id: 6,
    title: "Career Preparation",
    body: [
      "I am committed to supporting students in preparing for their chosen career paths. Whether a student is interested in academia or industry, I work with them to prepare academic research statements, job talks, or industrial applications as needed.",
      "I recognize that these paths are not mutually exclusive and strive to provide comprehensive support for various career trajectories.",
    ],
  },
];

export const howToApply = {
  title: "Interested in Joining?",
  body: "If our research directions resonate with you, please send an email with your CV, a short description of the research questions that interest you, and any relevant code or project links. Mention a specific AiR Lab project or paper so I know what drew you here. Prospective graduate students should also apply through the Department of Computer Science at LSU New Orleans. Undergraduates at LSU New Orleans are welcome to reach out about research assistantships and the Tolmas Undergraduate Research Scholars Program.",
  email: "aredwann@lsuneworleans.edu",
};
